const NotFound = () => {
    return (
        <div>
            <h2 style={{ marginBottom: 500 }}>Unfortunately, we couldn't find that page...</h2>

            <hr />
            <footer>
                <p>&copy; {new Date().getFullYear()} - National Kidney Registry. All rights reserved.</p>
            </footer>
        </div>
    );
}

export default NotFound;